<script setup lang="ts">
import {RouterView} from 'vue-router';
import {Users} from 'lucide-vue-next';
import AppShell from '@/views/shell/AppShell.vue';
import {type NavItem} from '@/views/shell/navItems.js';

const ITEMS: NavItem[] = [
    {label: 'Gebruikers', to: '/shared/user', icon: Users},
];
</script>

<template>
    <AppShell landing="Rapporteurbeheer" :items="ITEMS">
        <RouterView/>
    </AppShell>
</template>
